var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"20px","margin-left":"10px"}},[_vm._v("Bu pencere otomatik olarak kapanacak.")])}
var staticRenderFns = []

export { render, staticRenderFns }